export const login_success = (data) => ({ type: 'LOGIN_SUCCESS', data });
export const User_Permissions = (data) => ({ type: 'USER_PERMISSIONS', data });

export const logout = () => ({ type: 'LOG_OUT' });
